import { API } from '..';
import { requireTotpParams } from '../../utils/admin-stepup';

// Admin chỉnh cấu hình gamification (giá blind box, tỉ lệ, máy đào, nhiệm vụ).
// Backend: cab-payment-service, route admin qua gateway (Role Admin/Mod).
const BASE = '/v1/payment-service/admin/gamification';

export const getGameConfig = () =>
  API.get<Record<string, number>>(`${BASE}/config`).then((r) => r.data);

// Máy chủ bắt mã Authenticator khi đổi cấu hình (giá Blind Box, tỉ lệ rơi, Ca thưởng) — hỏi mã tại đây.
export const setGameConfig = async (values: Record<string, number>) => {
  const params = requireTotpParams('đổi cấu hình Ca đào');
  return API.post(`${BASE}/config`, { values }, { params }).then((r) => r.data);
};
